import React, { useEffect, useState } from "react";
import "./PageLoaderCM.css";

export default function UniquePageLoader() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="upl-loader-wrapper">
  <div className="upl-ripple-container">
    <div className="upl-ripple-circle"></div>
    <div className="upl-ripple-circle"></div>
  </div>
  <p className="upl-loader-text">Loading...</p>
</div>

  );
}
